import { IAutomationFilters, IAutomationBlueprint, IAutomation } from './Automation';
import { AutomationTriggerType } from './AutomationTrigger';
import { IAutomationExecutionVariable } from './AutomationVariable';
import { AutomationActionNodeSubType } from './AutomationNode';

export enum AutomationExecutionStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  TERMINATED = 'TERMINATED',
}

export interface IAutomationExecution {
  id: string;
  automationId: string;
  status: AutomationExecutionStatus;
  previousStatus?: AutomationExecutionStatus;
  triggerType: AutomationTriggerType;
  blueprint: IAutomationBlueprint;
  metadata: IAutomationExecutionMetadata;
  variables: IAutomationExecutionVariable[];
  createdDate: Date;
  updatedDate: Date;
  automation?: IAutomation;
}

export interface IExecutionError {
  actionType: AutomationActionNodeSubType;
  reason: string;
  metadata: {
    offerId?: number;
    productCatalogId?: number;
    selectionRuleId?: number;
    [key: string]: any;
  };
}

export interface IAutomationExecutionMetadata {
  idempotencyKey: string;
  failureReason?: string;
  errorMetadata?: string; // JSON stringified IExecutionError
}

export interface IAutomationExecutionFilters {
  id?: string;
  status?: AutomationExecutionStatus;
  automation?: IAutomationFilters;
  search?: string;
}
